"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "How does Inara Technologies tailor IT solutions for local businesses?",
  answer: "We begin with a deep-dive analysis of your current infrastructure and business goals. Our Nairobi-based team then designs custom AI models that address specific regional challenges, ensuring the solution is scalable, cost-effective, and culturally relevant to the East African market."
}, {
  question: "What cloud platforms do you support for migration?",
  answer: "We specialize in all major cloud providers including AWS, Microsoft Azure, and Google Cloud Platform. Our 'cloud-agnostic' approach allows us to recommend and implement the best environment for your specific workload, compliance needs, and budget."
}, {
  question: "Is your consulting available for startups in Nairobi?",
  answer: "Absolutely. We believe in empowering the local tech ecosystem. We offer scalable consulting packages specifically designed for startups, helping you implement robust cloud foundations and AI tools early on to support rapid growth without prohibitive upfront costs."
}, {
  question: "How do you ensure data security during digital transformation?",
  answer: "Security is embedded in every step of our process. We utilize industry-standard encryption, identity management protocols, and automated compliance checks. Our team ensures that your digital transformation adheres to both global standards and local data protection regulations."
}, {
  question: "What is the typical timeline for an AI integration project?",
  answer: "Timelines vary based on complexity, but a typical initial integration ranges from 4 to 12 weeks. We adopt an agile methodology, delivering functional milestones iteratively so you can start seeing value from automation and data insights as early as possible."
}];
export default function ExpertConsultationFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="expert-consultation-faq" className="dark bg-background text-foreground py-20 px-6 md:px-12 relative overflow-hidden">
      <div ref={ref} className={cn("max-w-3xl mx-auto transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-4 font-sans">
            Expert Consultation FAQ
          </h2>
          <p className="text-muted-foreground text-lg">Common questions about our IT consulting and Cloud services.</p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqData.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/40 last:border-0 px-2" data-index={i}>
              <AccordionTrigger className="group hover:no-underline py-6 [&>svg:last-child]:hidden">
                <span className="text-left text-lg font-medium text-white font-sans pr-8">
                  {faq.question}
                </span>
                <Plus className="size-6 shrink-0 text-primary transition-transform duration-300 group-data-[state=open]:rotate-45" />
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground pl-4 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}